var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightTabbarAssetsSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "light_tabbar_assets_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EFBF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DB8EB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-154, -58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(157, 60)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#0E1C39",
    strokeWidth: 2,
    fill: "#0E1C39",
    cx: 12,
    cy: 13,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,0 L13.0009262,6.42981291 C13.1486586,6.51530862 13.2877929,6.62126678 13.4142136,6.74768741 L18.2523126,11.5857864 C19.0333612,12.366835 19.0333612,13.633165 18.2523126,14.4142136 L13.4142136,19.2523126 C13.2877929,19.3787332 13.1486586,19.4846914 13.0009262,19.5701871 L13,26 L11,26 L11.000061,19.570758 C10.8519612,19.4851633 10.7124886,19.3790148 10.5857864,19.2523126 L5.74768741,14.4142136 C4.96663882,13.633165 4.96663882,12.366835 5.74768741,11.5857864 L10.5857864,6.74768741 C10.7124886,6.62098522 10.8519612,6.51483674 11.000061,6.42924197 L11,0 L13,0 Z M12,8.16190097 L7.16190097,13 L12,17.838099 L16.838099,13 L12,8.16190097 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTabbarAssetsSelected);
export default __webpack_public_path__ + "static/media/light_tabbar_assets_selected.70ce9e1ff3146b25acead9bfda428359.svg";
export { ForwardRef as ReactComponent };